import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      borderRadius: 16,
      overflow: "hidden",
      maxWidth: 600,
      width: "100%",
      margin: 16,
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    },
  },
  dialogTitle: {
    backgroundColor: "#000000",
    color: "#ffffff",
    padding: "16px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  titleText: {
    color: "#ffffff",
    fontSize: "1.125rem",
    fontWeight: 600,
    fontFamily: "'Inter', sans-serif, Roboto",
  },
  closeButton: {
    color: "#ffffff",
    padding: 4,
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.15)",
    },
  },
  closeIcon: {
    fontSize: 22,
    color: "#ffffff",
  },
  dialogContent: {
    backgroundColor: "#ffffff",
    padding: "32px 40px !important",
  },
  uploadLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: "#64748b",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
    marginBottom: 8,
    display: "block",
  },
  uploadBox: {
    border: "2px dashed #c7d2fe",
    borderRadius: 14,
    height: 120,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    padding: 12,
    outline: "none",
    "&:hover": {
      borderColor: "#818cf8",
      backgroundColor: "#f8fafc",
    },
  },
  uploadArrowIcon: {
    color: "#64748b",
    fontSize: 26,
    marginBottom: 6,
  },
  updateIconPill: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    color: "#334155",
  },
  cameraIcon: {
    fontSize: 18,
    color: "#334155",
  },
  updateIconText: {
    fontSize: 14,
    fontWeight: 500,
    color: "#334155",
  },
  previewImg: {
    maxHeight: 48,
    maxWidth: "100%",
    objectFit: "contain",
    marginBottom: 6,
    borderRadius: 6,
  },
  inputFieldLabel: {
    fontSize: 14,
    fontWeight: 500,
    color: "#334155",
    marginBottom: 6,
    display: "block",
  },
  customTextField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      backgroundColor: "#ffffff",
      fontSize: 14,
      color: "#0f172a",
      "& fieldset": {
        borderColor: "#e2e8f0",
      },
      "&:hover fieldset": {
        borderColor: "#cbd5e1",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#000000",
        borderWidth: 1,
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 14px",
    },
  },
  customSelect: {
    borderRadius: 10,
    backgroundColor: "#ffffff",
    fontSize: 14,
    color: "#0f172a",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e2e8f0",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#cbd5e1",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#000000",
      borderWidth: 1,
    },
    "& .MuiSelect-select": {
      padding: "10px 14px",
    },
  },
  actionButtonsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 16,
    marginTop: 24,
    marginBottom: 4,
  },
  closeButtonAction: {
    minWidth: 140,
    height: 42,
    borderRadius: 8,
    border: "1px solid #cbd5e1",
    color: "#0f172a",
    textTransform: "none",
    fontWeight: 500,
    fontSize: 14,
    backgroundColor: "#ffffff",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#f8fafc",
      borderColor: "#94a3b8",
      boxShadow: "none",
    },
  },
  submitButtonAction: {
    minWidth: 160,
    height: 42,
    borderRadius: 8,
    backgroundColor: "#000000",
    color: "#ffffff",
    textTransform: "none",
    fontWeight: 500,
    fontSize: 14,
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#1e293b",
      boxShadow: "none",
    },
  },
  errorMessage: {
    color: "#ef4444",
    fontSize: 12,
    marginTop: 4,
    display: "block",
  },
}));

export default useStyles;
